import * as React from 'react';
import { cn } from '@/lib/utils';

type Props = {
  heading: React.ReactNode;
  description?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

export function Section({ heading, description, children, className }: Props) {
  return (
    <div className={cn('flex min-w-0 border-b py-8 last:border-b-0', className)}>
      <div className="mr-4 flex min-w-48 max-w-48 flex-col">
        <div className="mb-4 font-medium">{heading}</div>
        {description ? <div className="text-muted-foreground text-sm">{description}</div> : null}
      </div>
      <div className="flex h-full w-full min-w-0 flex-col gap-6 pt-1">{children}</div>
    </div>
  );
}
